import { useTranslationSection } from './useTranslationSection'
import { UseTranslationOptions as OriginalUseTranslationOptions } from 'react-i18next'

interface UseTranslationOptions extends OriginalUseTranslationOptions {
  returnObjects?: boolean
}

export const useTranslationSectionObject = (
  section: string,
  options?: UseTranslationOptions,
) =>
  useTranslationSection(section, {
    returnObjects: true,
    ...options,
  })
